<template>
  <div class="tread-other">
      <div class="tread-input">
        <span class="trend-title">本月实际能耗</span>
        <el-input type="number" placeholder="请输入" v-model="energyData">
          <template slot="suffix">吨标媒</template>
        </el-input>
      </div>
      <div class="tread-input">
        <span class="trend-title">月平均能耗</span>
        <el-input type="number" placeholder="请输入" v-model="monthData">
          <template slot="suffix">吨标媒</template>
        </el-input>
        <el-input disabled="disabled" type="number" placeholder="对比" v-model="monthAverageDB">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="tread-input">
        <span class="trend-title">企业标准月能耗</span>
        <el-input type="number" placeholder="请输入" v-model="standardData">
          <template slot="suffix">吨标媒</template>
        </el-input>
        <el-input disabled="disabled" type="number" placeholder="对比" v-model="companyMonthPowerDB">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="tread-input">
        <span class="trend-title">行业标准月能耗</span>
        <el-input type="number" placeholder="请输入" v-model="tradeData">
          <template slot="suffix">吨标媒</template>
        </el-input>
        <el-input disabled="disabled" type="number" placeholder="对比" v-model="indMonthPowerDB">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="tread-input">
        <span class="trend-title">国家标准月能耗</span>
        <el-input type="number" placeholder="请输入" v-model="countryData">
          <template slot="suffix">吨标媒</template>
        </el-input>
        <el-input disabled="disabled" type="number" placeholder="对比" v-model="conutryMonthPowerDB">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="last-save">
         <el-button :loading="otherLoading" size="small" @click="saveOther" type="primary">保存</el-button>
      </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      otherLoading:false,//加载状态
      linshiID:'',
      //数据
      energyData:'',//本月实际能耗
      monthData:'',//月平均能耗
      standardData:'',//企业标准月能耗
      tradeData:'',//行业标准月能耗
      countryData:'',//国家标准月能耗

      monthAverageDB:'',//月平均能耗对比
      companyMonthPowerDB:'',//企业标准月能耗对比
      indMonthPowerDB:'',//行业标准月能耗对比
      conutryMonthPowerDB:'',//国家标准月能耗对比
    }
  },
  mounted(){
    this.getOther()
  },
  methods:{
    //保存数据
    saveOther(){
      this.otherLoading = true;
      let obj = {
        energyData:this.energyData,
        monthData:this.monthData,
        standardData:this.standardData,
        tradeData:this.tradeData,
        countryData:this.countryData,
      }
      if(this.linshiID){
        obj.id = this.linshiID
      }
      apis.saveBench(obj).then(res=>{
        if(res.code==10000){
          this.otherLoading = false;
          this.$message.success('保存成功');
          this.getOther()
        }else{
          this.otherLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
    //获取数据
    getOther(){
      apis.getBench().then(res=>{
        if(res.code==10000){
          let _data = res.data.list[0]
          this.energyData = _data.energyData
          this.monthData = _data.monthData
          this.standardData = _data.standardData
          this.tradeData = _data.tradeData
          this.countryData = _data.countryData
          this.linshiID = _data.id

          //对比
          this.monthAverageDB = (_data.energyData/_data.monthData*100).toFixed(2)
          this.companyMonthPowerDB = (_data.energyData/_data.standardData*100).toFixed(2)
          this.indMonthPowerDB = (_data.energyData/_data.tradeData*100).toFixed(2)
          this.conutryMonthPowerDB = (_data.energyData/_data.countryData*100).toFixed(2)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.tread-other{ padding-top: 10px;
  .tread-input{ margin-bottom: 15px;
    .trend-title{ width: 9rem;}
    .el-input,.el-select{ width: 12rem;}
  }
  .last-save{ margin-top: 2rem;}
}
</style>